import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { actionIcHome24px } from '@ey/motif-react-wrapper/assets/icons';
import { labels, currentResource } from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import MotifBreadcrumb from '@ey/motif-react-wrapper/Breadcrumb';
import MotifBreadcrumbItem from '@ey/motif-react-wrapper/BreadcrumbItem';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Modal from '../../Common/Modal/Modal';

function BreadCrumbNavigation(props) {
	const location = useLocation();
	const [isModalVisible, setModalVisibility] = useState(false);
	const isUnsavedUserDataModalOpen = useSelector((state) => state.isUnsavedUserDataModalOpen);
	const commonUnsavedDataState =  useSelector((state) => state.unsavedData);

	const getLinkAndLabel = (routeItem) => {
		var linkLabel = { link: routeItem.link, label: routeItem.label };
		if (routeItem.isDynamicLabel && location?.state) {
			var lbl = location?.state?.customLabel;
			if (lbl && lbl.length > 0) {
				linkLabel.label = lbl;
				linkLabel.link = location.pathname + location?.search;
			}
		}
		console.log(linkLabel);
		return linkLabel;
	};

	const changeRoutePath = (e) => {
		if (isUnsavedUserDataModalOpen || _.size(commonUnsavedDataState) > 0) {
			setModalVisibility(true);
			e.preventDefault();
		}
	};
	const redirectUser = () => {
		window.location = '/admin';
	};
	const closeModal = () => {
		setModalVisibility(false)
	}
	return (
		<Mainwrapper>
			<section className="breadcrumbwrapper">
				<MotifBreadcrumb>
					{props.breadCrumbList &&
						props.breadCrumbList.map((item) => {
							var dynamicLinkInfo = null;
							if (item.isDynamicLabel && location?.state) {
								dynamicLinkInfo = getLinkAndLabel(item);
							}
							return (
								<MotifBreadcrumbItem key={item.link} icon={null}>
									{item.isLastCrumb == true ? (
										<span title={Utility.removeTags(item.label)} className="last-crumb ellipsis">{Utility.removeTags(item.label)} </span>
									) : (
										<Link to={item.link} onClick={(e) => changeRoutePath(e)} title={Utility.removeTags(labels.homeLabel)}>
											{item.label == labels.homeLabel && (
												<MotifIcon
													src={actionIcHome24px}
													onMouseDown={() => { }}
													title={Utility.removeTags(labels.homeLabel)}
												/>
											)}
											<span title={Utility.removeTags(item.label)} className='crumb-item ellipsis'>{Utility.removeTags(item.label)}{' '}</span>
										</Link>
									)}
								</MotifBreadcrumbItem>
							);
						})}
				</MotifBreadcrumb>
			</section>
			<section>
				<Modal
					show={isModalVisible}
					showButtons
					modalsize={'small'}
					isOkButtonDisabled={false}
					hideCancelButton={false}
					title={labels.unSavedChanges}
					confirmBtnTitle={labels.confirm}
					closeBtnTitle={labels.cancelLabel}
					onOkClick={() => redirectUser()}
					onHide={() => closeModal()}
					closeTitle={labels.closeLabel}
				>
					<StyledModalBodySection>
						{Utility.createRichTextElement(labels.unSavedChangesMessage)}
					</StyledModalBodySection>
				</Modal>
			</section>
		</Mainwrapper>
	);
}

const Mainwrapper = styled.section`
	.motif-breadcrumb {
		height: 4.8rem;

		.motif-breadcrumb-list {
			height: 4.8rem;
		}

		.motif-breadcrumb-list-item {
			a {
				font-size: 1.2rem;
				color: ${(props) => props.theme.color[`grey500`]};
				display: flex;
				align-items: center;
				svg {
					width: 2rem !important;
					height: 2rem !important;
					max-width: 2rem !important;
					max-height: 2rem !important;
					fill: ${(props) => props.theme.color[`grey500`]};
				}
			}

			

			.motif-icon {
				width: 2rem !important;
				height: 2rem !important;		
			}
			.last-crumb {
				font-size: 1.2rem;
				font-weight: bold;
			}
			.crumb-item,
			.last-crumb{
				max-width: 55rem;
				margin-top: 0.5rem;
			}
			.motif-breadcrumb-arrow-separator{
				margin-top: 0.5rem;
			}
		}
		
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
`;
const StyledModalBodySection = styled.section`
	padding: 1rem 2rem;
	font-size:1.4rem;
`;
export default BreadCrumbNavigation;
